export const Divider = () => {
  return <div css={{ height: '36px', width: '1px', background: `rgba(0,0,0, 0.1)` }} />;
};
